import styled from 'styled-components';
import { editorTheme } from '../../theme';

const SettingsWrapper = styled.div`
  display: flex;
  position: relative;
  height: 40px;
  padding: 0 6px;
  background: ${editorTheme.surfaceMuted};
  border: 1px solid ${editorTheme.border};
  border-radius: 8px;
  align-items: center;
  justify-content: space-between;
`;

export default SettingsWrapper;
